import { useCallback, useEffect, useState } from "react";
import { RefreshCw, Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, ORDER_STATUS } from "@/lib/api";
import { OrderItem } from "@/components/OrderItem";

const FILTERS = [["pendentes", "Pendentes p/ admin"], ["all", "Todos"], ...Object.entries(ORDER_STATUS).map(([k, v]) => [k, v.label])];

export const OrdersPanel = () => {
  const [status, setStatus] = useState("pendentes");
  const [q, setQ] = useState("");
  const [orders, setOrders] = useState([]);
  const [summary, setSummary] = useState({});
  const load = useCallback(() => {
    api.get("/orders", { params: { status, q } }).then((r) => setOrders(r.data));
    api.get("/orders/summary").then((r) => setSummary(r.data));
  }, [status, q]);
  useEffect(() => { const t = setTimeout(load, 250); return () => clearTimeout(t); }, [load]);
  const pend = (summary.cliente_informou_pagamento || 0) + (summary.aguardando_ativacao || 0) + (summary.intervencao_manual || 0);

  return (
    <div className="space-y-4" data-testid="orders-view">
      <div className="flex flex-wrap gap-2">
        {FILTERS.map(([v, t]) => (
          <button key={v} onClick={() => setStatus(v)} className={`chip ${status === v ? "chip-active" : ""}`} data-testid={`orders-filter-${v}`}>
            {t}{v === "pendentes" ? ` (${pend})` : summary[v] ? ` (${summary[v]})` : ""}
          </button>
        ))}
      </div>
      <div className="flex gap-2">
        <div className="relative flex-1">
          <Search className="w-4 h-4 absolute left-3 top-3 text-[#6B7280]" />
          <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar por pedido, cliente, login Digital+ ou conversa" className="input-dark pl-9 h-10" data-testid="orders-search-input" />
        </div>
        <Button variant="outline" size="icon" className="btn-ghost h-10 w-10" onClick={load} data-testid="orders-refresh-button"><RefreshCw className="w-4 h-4" /></Button>
      </div>
      <p className="text-xs text-[#9CA3AF]">Pagamento e ativação são 100% MANUAIS: confira o recebimento na sua conta Mercado Pago e faça a renovação no Digital+ antes de confirmar aqui. Pedidos “SIMULADO” vêm do simulador.</p>
      {orders.length === 0
        ? <p className="text-sm text-[#6B7280] py-16 text-center" data-testid="orders-empty">Nenhum pedido neste filtro.</p>
        : <ul className="space-y-3" data-testid="orders-list">{orders.map((o) => <OrderItem key={`${o.id}-${o.updated_at}`} o={o} onDone={load} />)}</ul>}
    </div>
  );
};
